// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"479981d4","557":"786ca8eb","732":"503c3c46","765":"89f95f97","944":"a840b306"}[chunkId] + ".chunk.js";
};